export default __webpack_public_path__ + "static/media/Y_sound.25fd7b09.mp3";